var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.694 22.076H.306A.306.306 0 010 21.769V.307A.307.307 0 01.306 0h10.801a.306.306 0 010 .613H.612v20.85h14.776V4.902a.306.306 0 11.612 0v16.867a.307.307 0 01-.306.307z",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.107 5.208h4.587a.306.306 0 00.216-.523L11.324.09a.306.306 0 00-.523.217v4.595a.307.307 0 00.306.306zm3.848-.613h-3.542V1.047l3.542 3.548z",
    fill: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.962 8.306H4.038a.306.306 0 01-.265-.46.306.306 0 01.265-.153h7.924a.306.306 0 110 .613zm0 2.668H4.038a.306.306 0 010-.613h7.924a.306.306 0 010 .613zm0 2.668H4.038a.306.306 0 01-.265-.46.306.306 0 01.265-.153h7.924a.306.306 0 010 .613zm0 2.67H4.038a.306.306 0 01-.265-.46.306.306 0 01.265-.154h7.924a.306.306 0 010 .614zm0 2.668H4.038a.306.306 0 010-.614h7.924a.306.306 0 010 .613zM8.153 3.83H3.304a.306.306 0 010-.613h4.849a.306.306 0 010 .613z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTnc);
export default __webpack_public_path__ + "static/media/icon-tnc.dfc75213bf35dbcc56437779752769a3.svg";
export { ForwardRef as ReactComponent };